/**
 * Assemble the full payment response payload
 */
const createPaymentResponse = _ref => {
  let {
    detailRates = {},
    supportedDealTypes,
    isLeaseEnabled,
    paymentErrorState,
    isFinanceErrorState,
    isLeaseErrorState,
    udsLocalStateValues = {}
  } = _ref;
  const {
    obfuscatedCredit,
    activeTab,
    initialDealType,
    selectedCreditTier,
    selectedLoanTerm,
    selectedLeaseTerm,
    localTradeInValue,
    localAmountOwed,
    useCustomRate,
    customRate
  } = udsLocalStateValues;
  const {
    paymentOffers,
    nationalOffers,
    leaseOffers,
    cashOffers
  } = detailRates?.rates && detailRates?.rates[obfuscatedCredit] ? detailRates.rates[obfuscatedCredit] : {};
  const dealRates = {};
  if (supportedDealTypes.includes('finance')) {
    if (paymentOffers) {
      dealRates.paymentOffers = paymentOffers;
    } else if (nationalOffers) {
      dealRates.nationalOffers = nationalOffers;
    }
  }
  if (supportedDealTypes.includes('lease') && isLeaseEnabled && leaseOffers) {
    dealRates.leaseOffers = leaseOffers;
  }
  if (supportedDealTypes.includes('cash') && cashOffers) {
    dealRates.cashOffers = cashOffers;
  }
  return {
    rate: {
      [obfuscatedCredit]: dealRates
    },
    dealType: activeTab ?? initialDealType,
    creditType: selectedCreditTier,
    loanTerm: selectedLoanTerm,
    leaseTerm: selectedLeaseTerm,
    tradeInValue: localTradeInValue,
    amountOwed: localAmountOwed,
    customRate: useCustomRate ? customRate : null,
    paymentErrorState,
    isFinanceErrorState,
    isLeaseErrorState,
    supportedDealTypes
  };
};
export { createPaymentResponse as default };
